import { Observable } from 'rxjs';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import { makeStateKey, StateKey, TransferState } from '@angular/core';

export class TranslateBrowserLoader implements TranslateLoader {
  // Chemin/extension équivalents au défaut de TranslateHttpLoader v14
  // (en v17, le loader n'expose plus de constructor public pour passer http).
  private readonly prefix = '/assets/i18n/';
  private readonly suffix = '.json';

  constructor(
    private http: HttpClient,
    private transferState: TransferState,
  ) {}

  public getTranslation(lang: string): Observable<TranslationObject> {
    const key: StateKey<TranslationObject> = makeStateKey<TranslationObject>(
      'transfer-translate-' + lang,
    );
    const data = this.transferState.get(key, null as any);

    // SSR cache hit
    if (data) {
      return new Observable<TranslationObject>((observer) => {
        observer.next(data);
        observer.complete();
      });
    }
    // Fetch direct (équivalent v14 : GET /assets/i18n/{lang}.json)
    return this.http.get<TranslationObject>(this.prefix + lang + this.suffix);
  }
}

export function translateBrowserLoaderFactory(
  httpClient: HttpClient,
  transferState: TransferState,
): TranslateBrowserLoader {
  return new TranslateBrowserLoader(httpClient, transferState);
}
